"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FindCollectionStrategyEnum = void 0;
/** Стратегии поиска коллекций */
var FindCollectionStrategyEnum;
(function (FindCollectionStrategyEnum) {
  /**
   * Поиск для конструктора - все для конкретного автора author_id
   * required: IFindCollectionFilter.author_id
   */
  FindCollectionStrategyEnum["owned"] = "owned";
  /**
   * Поиск для библиотеки - промодерированные публичные
   */
  FindCollectionStrategyEnum["library"] = "library";
  /**
   * Поиск для профиля пользователя
   */
  FindCollectionStrategyEnum["profile"] = "profile";
  /**
   * Поиск в избранном - всё, что пользователь user_id добавил в избранное
   * required: ctx.state.user.id
   */
  FindCollectionStrategyEnum["favorites"] = "favorites";
  /**
   * Коллекции, доступные в школе
   * required: IFindCollectionFilter.shared_school_id
   */
  FindCollectionStrategyEnum["shared_school"] = "shared_school";
  /**
   * Приобретённые коллекции
   * extra: IFindCollectionFilter.purchased_license
   * required: ctx.state.user.id
   */
  FindCollectionStrategyEnum["purchased"] = "purchased";
})(FindCollectionStrategyEnum = exports.FindCollectionStrategyEnum || (exports.FindCollectionStrategyEnum = {}));
